/*
  Loads a PDF into an iframe only on mouse-only devices.

  Mobile browsers can't render a PDF inside an iframe: Android downloads it
  and iOS shows at most the first page. Hiding the iframe with CSS doesn't stop
  it loading, so the URL lives in data-src and is copied to src here only when
  the inline preview will actually be shown.

  Any touch input counts as touch, so a tablet with a trackpad (primary pointer
  "fine") still gets the native viewer. Must match the pdf-inline variant in
  assets/css/app.css.

  Usage:
    <iframe
      id="unique-per-file"
      phx-hook="PdfInlineFrameHook"
      phx-update="ignore"
      data-src={@url}
      class="hidden pdf-inline:block"
    ></iframe>
*/

const PDF_INLINE_QUERY = "(pointer: fine) and (not (any-pointer: coarse))";

const PdfInlineFrameHook = {
  mounted() {
    if (window.matchMedia(PDF_INLINE_QUERY).matches) {
      this.el.src = this.el.dataset.src;
    }
  },
};

export default PdfInlineFrameHook;
